import { render } from "./TVPHighlights.vue?vue&type=template&id=bb27083e"
import script from "./TVPHighlights.vue?vue&type=script&lang=js"
export * from "./TVPHighlights.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__